// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  --background: transparent;
  color: var(--ion-color-primary);
  box-shadow: none;
}
@media (width < 390px) {
  ion-button {
    font-size: 9px;
  }
}

.icon-only {
  font-size: var(--icon-size, 22px) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/burger-btn/burger-btn.component.scss"],"names":[],"mappings":"AAAA;EACC,yBAAA;EACA,+BAAA;EACA,gBAAA;AACD;AACC;EALD;IAME,cAAA;EAEA;AACF;;AACA;EACC,4CAAA;AAED","sourcesContent":["ion-button {\n\t--background: transparent;\n\tcolor: var(--ion-color-primary);\n\tbox-shadow: none;\n\n\t@media (width < 390px) {\n\t\tfont-size: 9px;\n\t}\n}\n\n.icon-only {\n\tfont-size: var(--icon-size, 22px) !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
